import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { SaleUpdateFiscalizationStatusCommand, SaleUpdateFiscalizationStatusCommandHandlerBase } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(SaleUpdateFiscalizationStatusCommand)
@Injectable({ providedIn: 'root' })
export class SaleUpdateFiscalizationStatusCommandHandler {
    private commandHandler: SaleUpdateFiscalizationStatusCommandHandlerBase;

    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new SaleUpdateFiscalizationStatusCommandHandlerBase(http);
    }

    public async handleAsync(params: SaleUpdateFiscalizationStatusCommand): Promise<string | undefined> {
        return await this.commandHandler.handleAsync(params);
    }
}
